
export enum enumAppPlatformType {
  Android = 'Android', // runs on the Google Android platform
  iOS = 'iOS', // runs on the Apple iOS platform
  Web = 'Web', // runs as a Web Application
  Unknown = 'Unknown', // an unknown value
}
